import { render, staticRenderFns } from "./dui-youtube-video.vue?vue&type=template&id=39bf7584&"
import script from "./dui-youtube-video.vue?vue&type=script&lang=js&"
export * from "./dui-youtube-video.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports